import { Box } from "@mui/material";
import { Handle } from "reactflow";


const UnsFlowNode = ({ data }) => {
    // List of Firebase images that need larger scaling (these appear smaller visually)
    const firebaseImages = [
      'insize.png',
      'brecknell.png', 
      'iconics.png',
      'ignition.png',
      'rockweel.png', // Note: this has a typo in the filename but matches your URL
      'litmus_edge.png',
      'litmus_uns.png',
      'aveva.png',
      'cognite.png',
      'tulip_player.png',
      'tulip_tables.png',
      'machines.png',
      'kolver.png',
      'placeholder.png',
      'assembly_cell.png',
      'supplier_cell.png',
      'chmi_cell.png',
      'adef_cell.png',
      'zaether.png',
      'bioreactor_station.png',
      'lab_companion.png',
      'weigh_dispense.png',
      'vis_inspection.png'
    ];
    
    // Check if current image is a Firebase image that needs scaling
    const needsLargerScaling = firebaseImages.some(filename => data.img && data.img.includes(filename));
    
    const imageStyle = needsLargerScaling ? {
      height: '90px', // Larger height for Firebase images
      width: 'auto',
      maxWidth: '143px',
      objectFit: 'contain'
    } : {
      height: '30px', // Standard height for Tulip CDN images
      width: 'auto',
      maxWidth: '120px',
      objectFit: 'contain'
    };
    
    return (
    <div>
      {data.targetPosition && <Handle type="target" position={data.targetPosition} style={{opacity:0}} />}
      <Box
        sx={{
          borderColor: "transparent",
          borderWidth: '2px',
          borderRadius: '3px',
          boxSizing: "border-box",
          color: data?.active ? "white" : "black",
          textAlign: "center",
          cursor: "pointer",
          pointerEvents: "all",
          height: "auto",
          minHeight: "30px",
          maxHeight: "40px",
          width: "auto",
          minWidth: "80px",
          maxWidth: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2px",
        }}
        onClick={() => data.onClick(data.id)}
      >
        <img 
          src={data.img} 
          style={imageStyle}
          alt={data.id}
        />
      </Box>
      {data.sourcePosition && <Handle type="source" position={data.sourcePosition} style={{opacity:0}} />}
      
      
    </div>
  );
};

export default UnsFlowNode;